<template>
  <v-data-table
    :headers="headers"
    :items="estudios"
    class="transparent"
    :loading="loading"
    :options="{ page: false }"
    :hide-default-footer="true"
  >
    <template v-slot:[`item.opciones`]="{ item }">
      <span class="d-flex align-center">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <IconButton class="mr-2" icon="mdi-pencil" variant="primary" @click="$emit('edit', item)" />
            </span>
          </template>
          <span>Editar Estudio</span>
        </v-tooltip>
      </span>
    </template>
  </v-data-table>
</template>

<style scoped>
/* Estilos modernos para EstudiosTable */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
  border-radius: 12px;
}

/* Encabezados de tabla */
::v-deep .v-data-table-header {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: var(--v-secondary-base) !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(var(--v-secondary-base-rgb), 0.3) !important;
  padding: 16px !important;
}

/* Filas de la tabla */
::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
  border-radius: 8px;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.1) !important;
  transform: scale(1.005);
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb), 0.2);
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.1) !important;
  padding: 16px !important;
}

/* Loading state */
::v-deep .v-data-table__progress {
  background: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

::v-deep .v-data-table__progress .v-progress-linear__determinate {
  background: var(--v-secondary-base) !important;
}

/* Empty state */
::v-deep .v-data-table__empty-wrapper {
  color: rgba(224, 224, 224, 0.6) !important;
}

/* Botones en la tabla */
::v-deep .v-btn {
  border-radius: 12px !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 30, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Data footer */
::v-deep .v-data-footer {
  background: rgba(18, 18, 18, 0.5) !important;
  border-top: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__select .v-select {
  color: #e0e0e0 !important;
}

::v-deep .v-data-footer__pagination {
  color: #e0e0e0 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}

/* Animación de entrada */
::v-deep .v-data-table {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>

<script>
import IconButton from '../../base/IconButton.vue'

export default {
  components: {
    IconButton,
  },
  props: {
    estudios: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Institución', value: 'institucion', width: '20%' },
        { text: 'Generación', value: 'generacion', width: '15%' },
        { text: 'Estatus', value: 'CatEstatusEstudio.title', width: '15%' },
        { text: 'Comprobante', value: 'ComprobanteEstudio.title', width: '15%' },
        { text: 'Grado', value: 'CatEstudios.title', width: '15%' },
        { text: 'Observaciones', value: 'observaciones', width: '30%' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%', sortable: false },
      ],
    }
  },
}
</script>
